import styled, {css} from 'styled-components'

export const StyledFiltersBar = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
        border-top: 1px solid ${palette.neutral[200]};
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)
